<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Application Settings</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card">
        <div class="card-body mt-3 mb-3">
          <div class="row" style="margin-left: 15px; margin-right: 15px">
            <div class="col-12 col-lg-3"></div>
            <div class="col">
              <div class="form-group d-flex float-end">
                <b-button v-b-modal.modal-1 variant="primary">
                  <span class="fe fe-plus-circle"></span>
                  Add Application
                </b-button>
              </div>
            </div>
          </div>

          <div>
            <vue-good-table
              :line-numbers="true"
              :columns="column"
              :rows="listAppVariables"
              :sort-options="{
                enabled: true
              }"
              :total-rows="10"
              :pagination-options="{
                enabled: false,
                mode: 'pages',
                position: 'bottom',
                perPage: 10,
                perPageDropdown: [10, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Rows per page',
                ofLabel: 'of',
                pageLabel: 'page',
                allLabel: 'All'
              }"
              style-class="vgt-table border-0 table">
              <!-- Loading -->
              <div slot="emptystate" class="text-center font-size-14">
                No data available
              </div>
              <!-- Custom Rows -->
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <b-button
                    class="no-wrap btn-pill"
                    variant="warning"
                    size="sm"
                    @click="editVariables(props.row)">
                    <span class="fe fe-edit"></span>
                  </b-button>
                  <b-button
                    class="no-wrap ml-2"
                    variant="danger"
                    style="margin-left: 5px"
                    size="sm"
                    @click="deleteVariables(props.row.id)">
                    <span class="fe fe-trash-2"></span>
                  </b-button>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-1" size="xl" hide-footer title="Add Application">
      <form @submit.prevent="saveVariables()">
        <div class="row g-3">
          <div class="form-group col">
            <label>Application Name <span class="text-danger">*</span></label>
            <v-select
              v-model="bodyAdd.selectAppName"
              :options="applicationNames"
              :reduce="(e) => e.label"
              v-validate="'required'"
              name="Select Form Type" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
          <div class="form-group col">
            <label>Parameter Name <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyAdd.parameter_name"
              class="form-control"
              placeholder="Parameter Name"
              v-validate="'required'"
              name="Parameter Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Parameter Name')"
              >{{ errors.first("Parameter Name") }}</span
            >
          </div>
          <div class="row g-3">
            <div class="form-group col">
              <label>Data Type <span class="text-danger">*</span></label>
              <v-select
                v-model="bodyAdd.selectDataType"
                :options="optionsDataType"
                :reduce="(e) => e.label"
                v-validate="'required'"
                name="Select Data Type" />

              <span
                class="text-sm text-danger"
                v-show="errors.has('Data Type')"
                >{{ errors.first("Data Type") }}</span
              >
            </div>
            <div class="form-group col">
              <label>Length <span class="text-danger">*</span></label>
              <input
                type="number"
                v-model="bodyAdd.lengthVariables"
                class="form-control"
                placeholder="Length"
                v-validate="'required'"
                name="lengt" />
              <span class="text-sm text-danger" v-show="errors.has('Length')">{{
                errors.first("Length")
              }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-1')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal id="modal-2" size="xl" hide-footer title="Edit Application">
      <form @submit.prevent="saveUpdate()">
        <div class="row g-3">
          <div class="form-group col">
            <label>Application Name <span class="text-danger">*</span></label>
            <v-select
              v-model="bodyUpdate.selectAppName"
              :options="applicationNames"
              :reduce="(e) => e.value"
              v-validate="'required'"
              name="Select Form Type" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Select App Name')"
              >{{ errors.first("Select App Name") }}</span
            >
          </div>
          <div class="form-group col">
            <label>Parameter Name <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="bodyUpdate.parameter_name"
              class="form-control"
              placeholder="Parameter Name"
              v-validate="'required'"
              name="Parameter Name" />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Parameter Name')"
              >{{ errors.first("Parameter Name") }}</span
            >
          </div>
          <div class="row g-3">
            <div class="form-group col">
              <label>Data Type <span class="text-danger">*</span></label>
              <v-select
                v-model="bodyUpdate.selectDataType"
                :options="optionsDataType"
                :reduce="(e) => e.value"
                v-validate="'required'"
                name="Select Data Type" />

              <span
                class="text-sm text-danger"
                v-show="errors.has('Data Type')"
                >{{ errors.first("Data Type") }}</span
              >
            </div>
            <div class="form-group col">
              <label>Length <span class="text-danger">*</span></label>
              <input
                type="number"
                v-model="bodyUpdate.lengthVariables"
                class="form-control"
                placeholder="Length"
                v-validate="'required'"
                name="lengt" />
              <span class="text-sm text-danger" v-show="errors.has('Length')">{{
                errors.first("Length")
              }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false">
            Save
          </button>
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
            v-else>
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
            Loading...
          </button>
          <button
            type="button"
            style="margin-right: auto; float: right"
            class="mt-4 btn btn-outline-primary mr-3"
            @click="$bvModal.hide('modal-1')">
            Cancel
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "RoleTemplate",
  computed: {
    listEmployee() {
      return this.$store.getters["role_assigment/listEmployee"];
    },
    listApp() {
      return this.$store.getters["role_template/listApp"];
    },
    listRoles() {
      return this.$store.getters["role_template/listRoles"];
    },
    listEmployeeById() {
      return this.$store.getters["role_assigment/EmployeeById"];
    },
    listUserAtributr() {
      return this.$store.getters["users/listUsers"];
    },
    listAppVariables() {
      return this.$store.getters["role_template/listVariables"];
    }
  },
  data() {
    return {
      applicationNames: [],
      listVariables: [],
      fullname: "",
      departement: "",
      position: "",
      employee: "",
      app: "",
      role: "",
      isAdd: true,
      isRole: false,
      loadRole: false,
      isLoading: false,
      assignBy: "",
      selectFormType: "",

      usersAttribute: [],
      bodyAdd: {
        selectAppName: "",
        selectDataType: "",
        parameter_name: "",
        lengthVariables: ""
      },
      bodyUpdate: {
        id: "",
        selectAppName: "",
        selectDataType: "",
        parameter_name: "",
        lengthVariables: ""
      },
      optionsDataType: [
        {
          label: "String",
          value: "string"
        },
        {
          label: "Integer",
          value: "integer"
        }
      ],
      column: [
        {
          label: "Application Name",
          field: "application_name",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Parameter Name",
          field: "parameter_name",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Data Type",
          field: "data_type",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Length",
          field: "length",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle"
        },
        {
          label: "Actions",
          field: "actions",
          thClass:
            "table-header no-wrap w-40 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
          sortable: false
        }
      ]
    };
  },

  mounted() {
    this.assignBy = localStorage.getItem("fullname");
    this.getApp();
    this.getUsersAttribute();
    this.getVariables();
  },
  methods: {
    getApp() {
      this.$store
        .dispatch("role_template/GET_LIST_APP")
        .then((response) => {
          this.applicationNames = this.listApp.data.map((app) => ({
            label: app.name,
            value: app.id
          }));
        })
        .catch((error) => {
          console.error("Error fetching application names:", error);
        });
    },

    getUsersAttribute() {
      this.$store.dispatch("users/GET_LIST_USERS");
    },

    getVariables() {
      this.$store
        .dispatch("role_template/GET_LIST_VARIABLES")
        .then((response) => {
          this.listVariables = response.result.data.rows;
        })
        .catch((error) => {
          console.error("Error fetching variables:", error);
        });
    },

    saveVariables() {
      console.log("clicked");
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        // return console.log("payload variables :", this.bodyAdd);
        this.isLoading = true;
        try {
          let body = {
            application_name: this.bodyAdd.selectAppName,
            parameter_name: this.bodyAdd.parameter_name,
            data_type: this.bodyAdd.selectDataType,
            length: this.bodyAdd.lengthVariables
          };
          this.$store
            .dispatch("role_template/CREATE_VARIABLES", body)
            .then((resp) => {
              this.$swal("Saved", "Saved data success", "success").then(() => {
                this.bodyAdd = {
                  selectAppName: "",
                  selectDataType: "",
                  parameter_name: "",
                  length: ""
                };
                this.getVariables();
                this.isLoading = false;
                this.$bvModal.hide("modal-1");
              });
            });
        } catch (error) {
          this.$swal("Error", "Error while add data", "error");
        }
      });
    },

    editVariables(props) {
      console.log("props", props);
      this.$bvModal.show("modal-2");
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.selectAppName = props.application_name;
      this.bodyUpdate.selectDataType = props.data_type;
      this.bodyUpdate.parameter_name = props.parameter_name;
      this.bodyUpdate.lengthVariables = props.length;
    },
    saveUpdate() {
      let body = {
        id: this.bodyUpdate.id,
        application_name: this.bodyUpdate.selectAppName,
        parameter_name: this.bodyUpdate.parameter_name,
        data_type: this.bodyUpdate.selectDataType,
        length: this.bodyUpdate.lengthVariables
      };
      this.$store
        .dispatch("role_template/updateVariables", body)
        .then((resp) => {
          this.$swal("Saved", "Your input has been saved", "success").then(
            (resp) => {
              this.getVariables();
              this.$bvModal.hide("modal-2");
            }
          );
        })
        .catch((resp) => {
          this.$swal("Error", "Error while edit data", "error");
        });
    },

    deleteVariables(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("role_template/delVariables", id)
            .then((resp) => {
              this.getVariables();
              this.$swal("Deleted!", "Your file has been deleted.", "success");
            })
            .catch((resp) => {
              this.$swal("Error", "Error while delete data", "error");
            });
        }
      });
    }
  }
};
</script>
